import validations from './validations';

export default {
  ...validations,
  invoice_flow__multi_time_remainin: 'Tempo restante',
  invoice_flow__multi_or: 'Ou',
  invoice_flow__multi_open_app: 'Abrir no aplicativo',
  invoice_flow__multi_return_button: 'Voltar ao site',
  invoice_flow__card_transfer_button: 'Confirmar',

  //Steps
  invoice_flow__multi_upi_qr_step_1: 'Escaneie o código QR acima',
  invoice_flow__multi_upi_qr_step_2: 'Faça um pagamento',
  invoice_flow__multi_step_3:
    'Confirme o pagamento fornecendo <b>{attributes}</b> e pressione o botão "Confirmar"',
  invoice_flow__multi_upi_qr_mob_step_1:
    'Digitalize o código QR acima ou use o botão "Abrir no aplicativo"',

  invoice_flow__multi_bank_transfer_step_1: 'Copiar detalhes',
  invoice_flow__multi_bank_transfer_step_2: 'Faça um pagamento',
};
